import React, { useState, useEffect, useContext, useMemo } from 'react';
import { LykioContext } from "../routing/LykioAuthorizedRoute";
import axios from 'axios';
import Modal from 'react-bootstrap/Modal';
import { Link, useParams } from 'react-router-dom';
import {
  AUTHORIZED_URL_PREFIX,
  USER_MANAGEMENT_WITHOUTPARAM_URL,
  USER_MANAGEMENT_ADD_USER_URL,
  USER_MANAGEMENT_ADD_GROUP_URL,
  DEPARTMENTS_URL,
  MASS_USER_UPLOAD_URL,
  NOTIFICATION_SEVERITY_INFO,
  NOTIFICATION_SEVERITY_WARNING,
  AxiosConfig
} from '../../Utils/Constants';
import './userManagement.css';
import t from "../../Utils/Translation";
import Form from 'react-bootstrap/Form';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import LykioButton from "../common/LykioButton";
import Loading from '../common/Loading';
import { notify, pleaseRefreshError } from '../../Utils/Notificator';
import UsersTable from './UsersTable';
import TextSnippetSharpIcon from '@mui/icons-material/TextSnippetSharp';

const UserManagement = () => {
  const context = useContext(LykioContext);
  const userDetails = context.userDetails;
  const userPermissions = context.userPermissions;
  const tenantProperties = context.tenantProperties;

  // Set local storage for admin assignment if not already set
  const localCanAssignAdmin = localStorage.getItem('localca');
  if (localCanAssignAdmin === null) {
    localStorage.setItem(
      'localca',
      userPermissions ? (!userPermissions.includes('teacherusermanagement')).toString() : 'false'
    );
  }
  const assignAdminRole = localStorage.getItem('localca') === 'true';

  const [isLoading, setIsLoading] = useState(true);
  const [file, setFile] = useState();
  const [users, setUsers] = useState([]);
  const [groups, setGroups] = useState([]);
  const { groupReference } = useParams();
  const [selectedGroup, setSelectedGroup] = useState(groupReference);
  const [searchTerm, setSearchTerm] = useState('');

  // Derive filteredUsers using useMemo based on the current users and searchTerm.
  const filteredUsers = useMemo(() => {
    const term = searchTerm.toLowerCase();
    return users.filter(user => {
      const fullName = (user.fullName || '').toLowerCase();
      const email = (user.email || '').toLowerCase();
      return fullName.includes(term) || email.includes(term);
    });
  }, [users, searchTerm]);

  const fetchUserManagementData = async () => {
    try {
      setIsLoading(true);
      const { data } = await axios.post(
        `${AUTHORIZED_URL_PREFIX}${USER_MANAGEMENT_WITHOUTPARAM_URL}`,
        { groupReference },
        AxiosConfig()
      );
      setUsers(data.users);
      setGroups(data.groups);
      setSelectedGroup(data.selectedGroup);
      setIsLoading(false);
      if (!data.success) {
        notify(pleaseRefreshError);
      }
    } catch (error) {
      console.error(error);
      notify(pleaseRefreshError);
    }
  };

  useEffect(() => {
    fetchUserManagementData();
  }, [groupReference]);

  if (selectedGroup === undefined) {
    setSelectedGroup(groupReference);
  }

  return (
    <div className="lykioccs-main-content">
      {isLoading ? (
        <Loading />
      ) : (
        <div>
          <div style={{ marginLeft: '3px' }} className="lykiocss-title-light">
            {t('User Management')}
          </div>
          {/* Search Input */}
          <Form.Control
            type="text"
            placeholder={t('Search by name or email')}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ marginBottom: '10px', width: '300px' }}
          />

          {filteredUsers.length > 0 ? (
            <div className="lykiocss-material-table">
              <h5>
                {t('Total')} {`(${filteredUsers.length} users)`}
              </h5>
              <UsersTable key={searchTerm} users={filteredUsers} assignAdminRole={assignAdminRole} />
            </div>
          ) : (
            <div>
              {t('No entries for')} {selectedGroup}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default UserManagement;
